// jQuery('.mega-menu .header__menu-item').on('click', function(event) {
//     event.preventDefault();

//     jQuery(event.currentTarget)
//       .find('.mega-menu__content')
//       .toggleClass('menu-visible')
//       .parent()
//       .siblings()
//       .find('.mega-menu__content')
//       .removeClass('menu-visible')

//     jQuery('.mega-menu__content').click(function(e) {
//       e.stopPropagation();
//     });
// });

jQuery(function ($) {
  function activatePane($container, paneKey) {
    // left active state
    $container.find('.mega-menu__left-item').removeClass('is-active');
    $container.find('.mega-menu__left-item[data-pane="' + paneKey + '"]').addClass('is-active');

    // right pane active state
    $container.find('.mega-menu__pane').removeClass('is-active');
    $container.find('.mega-menu__pane[data-pane="' + paneKey + '"]').addClass('is-active');
  }

  // Hover/focus a left item -> show that pane
  $(document).on('mouseenter focusin', '.mega-menu__container--two-col .mega-menu__left-item', function () {
    var $item = $(this);
    var paneKey = $item.data('pane');
    var $container = $item.closest('.mega-menu__container--two-col');
    activatePane($container, paneKey);
  });

  // When menu opens, ensure first pane is active (defensive)
  $(document).on('mouseenter', '.mega-menu', function () {
    var menuId = $(this).data('menu');
    var $panel = $('#' + menuId);
    var $container = $panel.find('.mega-menu__container--two-col').first();
    if (!$container.length) return;

    var $active = $container.find('.mega-menu__left-item.is-active').first();
    var $first = $container.find('.mega-menu__left-item').first();

    // If none active for any reason, set first
    if (!$active.length && $first.length) {
      activatePane($container, $first.data('pane'));
    }
  });
});

$(document).ready(function () {

    document.querySelectorAll('.mega-menu-wrapper').forEach((wrap) => {
        const idx = wrap.getAttribute('data-menu-index');
        const tiles = wrap.querySelectorAll('.mega-menu__image-wrapper');

        const setActive = () => {
            tiles.forEach((t) => t.classList.remove('is-active'));
            // pick matching index (or default first)
            const match = wrap.querySelector(`.mega-menu__image-wrapper[data-menu-index="${idx}"]`);
            (match || tiles[0])?.classList.add('is-active');
        };

        wrap.addEventListener('mouseenter', setActive);
        wrap.addEventListener('focusin', setActive);
    });

jQuery('.mega-menu-wrapper').each(function () {
    var $wrapper = jQuery(this);
    var index = $wrapper.data('menu-index');

    $wrapper.on('mouseover', function () {
      jQuery('.mega-menu__image-wrapper').each(function () {
        var $img = jQuery(this);
        if ($img.data('menu-index') == index) {
          $img.removeClass('hide-img');
        } else {
          $img.addClass('hide-img');
        }
      });
    });

    $wrapper.on('mouseleave', function () {
      // Delay check to allow mouse to move within the wrapper
      setTimeout(function () {
        var stillHovered = $wrapper.is(':hover');
        if (!stillHovered) {
          jQuery('.mega-menu__image-wrapper[data-menu-index="' + index + '"]').addClass('hide-img');
        }
      }, 100);
    });
  });



  
  // Show/hide grandchildren menu blocks on hover
  // $('.child-link').on('mouseenter', function () {
  //   var handle = $(this).data('child-handle');

  //   // Hide all grandchildren blocks
  //   $('.grandchildren__block').addClass('hide-grandchildren');

  //   // Show the matching block
  //   $('.grandchildren__block[data-grandchildren-handle="' + handle + '"]').removeClass('hide-grandchildren');
  // });
  
  // $('.mega-menu__link').on('mouseenter', function () {
  //   var handle = $(this).data('menu-handle');

  //   // Hide all images
  //   $('.mega-menu__image-wrapper').addClass('hide-img');

  //   // Show matching image
  //   $('.mega-menu__image-wrapper[data-image-handle="' + handle + '"]').removeClass('hide-img');
  // });

  // // Optional: hide all images on mouse leave of entire menu
  // $('.mega-menu__content').on('mouseleave', function () {
  //   $('.mega-menu__image-wrapper').addClass('hide-img');
  // });

  // $('.mega-menu__content').on('mouseleave', function () {
  //   $('.grandchildren__block').addClass('hide-grandchildren');
  // });
});

jQuery(document).keyup(function(e) {
    if (e.key == "Escape") {
        jQuery('.search-modal').removeClass('search-open');
        jQuery('body').removeClass('overflow-hidden');
    }
});

jQuery(document).ready(function() {

    // setTimeout(function() {
    //     jQuery('.appikon-cart-item-upsell-notes').each(function() {
    //         if(jQuery(this).html() != '') {
    //             jQuery(this).addClass('ready');
    //         }
    //     });
    // }, 1800);

    setTimeout(function() {

        jQuery('.card').each(function() {
            if(jQuery(this).find('.bss_pl_label_text').length != 0) {
                jQuery(this).find('.card__information').addClass('promo-margins');
            }
        });
    }, 1200);

    jQuery('.header__icon--search').click(function() {
        jQuery(this).next('.search-modal').addClass('search-open');
        jQuery('body').addClass('overflow-hidden');
    });

    jQuery('.search-modal__close-button').click(function() {
        jQuery(this).closest('.search-modal').removeClass('search-open');
        jQuery('body').removeClass('overflow-hidden');
    });

    setTimeout(function() {
        jQuery('.mega-menu__content').removeClass('hidden');
        jQuery('.featuredCarousel').addClass('is-ready');
        jQuery('.videoBox').addClass('is-ready');
    }, 50);
});

if(jQuery(".swiper-container .swiper-slide").length == 1) {
    jQuery('.swiper-pagination').addClass( "disabled" );
}

jQuery('.mega-menu').each(function() {
    var $this = jQuery(this);
    var menuId = $this.data('menu');
    var $menuContent = jQuery('#' + menuId);
    var hideTimeout;

    // $this.on('mouseenter', function() {
    //     clearTimeout(hideTimeout); // Prevent quick hide on accidental mouse movement
    //     jQuery('.mega-menu__content').not($menuContent).removeClass('open-sesame');
    //     $menuContent.addClass('open-sesame');

    //     jQuery('body, html').addClass('menu-open');
    // });

    // $this.on('mouseleave', function() {
    //     hideTimeout = setTimeout(function() {
    //         $menuContent.removeClass('open-sesame');
    //         if (jQuery('.mega-menu__content.open-sesame').length === 0) {
    //             jQuery('body, html').removeClass('menu-open');
    //         }
    //     }, 300); // Short delay to prevent flickering
    // });

    // $menuContent.on('mouseenter', function() {
    //     clearTimeout(hideTimeout); // Keep the menu open if mouse enters the content
    // });

    // $menuContent.on('mouseleave', function() {
    //     hideTimeout = setTimeout(function() {
    //         $menuContent.removeClass('open-sesame');
    //         if (jQuery('.mega-menu__content.open-sesame').length === 0) {
    //             jQuery('body, html').removeClass('menu-open');
    //         }
    //     }, 300);
    // });
});

// jQuery('.mega-menu').each(function() {
//     jQuery(this).hover(function() {
//         var a = jQuery(this).data('menu');
//         var b = jQuery('#' + a);
//         jQuery('.mega-menu__content').not(b).removeClass('open-sesame');
//         b.toggleClass('open-sesame');

//         if( jQuery(b).hasClass('open-sesame') ) {
//             jQuery('.section-header').addClass('menu-open');
//             jQuery('body').addClass('menu-open');
//             jQuery('html').addClass('overflow-hidden');
//         } else {
//             jQuery('.section-header').removeClass('menu-open');
//             jQuery('body').removeClass('menu-open');
//             jQuery('html').removeClass('overflow-hidden');
//         }
//         // jQuery(this).toggleClass('open-sesame');
//         // jQuery('.section-header').toggleClass('menu-open');
//         // jQuery('html').toggleClass('overflow-hidden');
//     });
// });

const swiper = new Swiper('.CarouselSimple__carousel', {
    slidesPerView: "auto",
    fadeEffect: {
        crossFade: true
    },
    speed: 500,
    navigation: {
      nextEl: '.CarouselChosenSimple__button--next',
      prevEl: '.CarouselChosenSimple__button--prev',
    },
});

const featuredCarousel = new Swiper('.featuredCarousel__carousel', {
    slidesPerView: 1,
    watchSlidesProgress: true,
    watchOverflow: true,
    effect: 'slide',
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
    },
    loopPreventsSlide: false,
    // speed: 500,
    navigation: {
      nextEl: '.CarouselFeaturedSimple__button--next',
      prevEl: '.CarouselFeaturedSimple__button--prev',
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: 'false',
        type: 'bullets',
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + '<i></i>' + '<b></b>'  + '</span>';
        }
    },
});


const quoteCarousel = new Swiper('.quoteCarousel__carousel', {
    slidesPerView: 1,
    spaceBetween: 30,
    watchOverflow: true,
    loop: true,
    effect: 'slide',
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
    },
    allowTouchMove: true,
    navigation: {
        nextEl: '.CarouselQuoteSimple__button--next',
        prevEl: '.CarouselQuoteSimple__button--prev',
    },
});

const featuredHomepageCarousel = new Swiper('.featuredHomepageCarousel__carousel', {
    slidesPerView: 1,
    watchSlidesProgress: true,
    watchOverflow: true,
    zoom: true,
    effect: 'slide',
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
    },
    allowTouchMove: true,
    rewind: true,
    loopPreventsSlide: false,
    navigation: {
      nextEl: '.CarouselSimple__button--next',
    //   prevEl: '.CarouselSimple__button--prev',
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: 'false',
        type: 'bullets',
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + '<i></i>' + '<b></b>'  + '</span>';
        }
    },
});

if(jQuery('.masonry').length > 0) {
    var macyInstance = Macy({
        container: '.masonry .container',
        columns: 2,
        margin: 24,
        trueOrder: true,
        breakAt: {
            760: {
              margin: {
                x: 20,
              },
              columns: 2
            },
            500: {
                margin: {
                  x: 10,
                },
                columns: 1
              }
        }
    });
}

function isOnScreen(elem) {
	if( elem.length == 0 ) {
		return;
	}
	var $window = jQuery(window)
	var viewport_top = $window.scrollTop()
	var viewport_height = $window.height()
	var viewport_bottom = viewport_top + viewport_height
	var $elem = jQuery(elem)
	var top = $elem.offset().top
	var height = $elem.height()
	var bottom = top + height

	return (top >= viewport_top && top < viewport_bottom) ||
	(bottom > viewport_top && bottom <= viewport_bottom) ||
	(height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}

jQuery(window).scroll(function($) {

    function inViewport(node) {
        var rect = node.getBoundingClientRect()
        return (
            (rect.height > 0 || rect.width > 0) &&
            rect.bottom >= 0 &&
            rect.right >= 0 &&
            rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.left <= (window.innerWidth || document.documentElement.clientWidth)
        )
    }

    var windowWidth = jQuery(window).width();

    if(windowWidth > 768) {
        var scrolled = jQuery(window).scrollTop()
        jQuery('.parallax').each(function (index, element) {
            var initY = jQuery(this).offset().top;
            var height = jQuery(this).height();

            // Check if the element is in the viewport.
            var visible = inViewport(this);
            if (visible) {
                var diff = scrolled - initY
                var ratio = Math.round((diff / height) * 100)
                jQuery(this).css('background-position', 'center ' + parseInt((ratio * 1.5)) + 'px')
            }
        })

        // jQuery('.parallax-figure').each(function (index, element) {

        //     var target = jQuery(this);

        //     var height = window.innerHeight;

        //     var itemHeight = jQuery(this).outerHeight();

        //     var scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

        //     jQuery(target).css('transform', "translate3d(0px, " + (height - scrollTop) / 3 + "px, 0px)");
            
        // });
        
    }

    jQuery('.parallax-figure').each(function(i){
        if( isOnScreen(this) ) {
            var row = jQuery(this);
            setTimeout(function() {
                row.addClass('fadeInUp');
            }, 200*i);
        }
    });
});

// jQuery(document).ready(function($) {
//     //Scroll back to top
//     jQuery('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
//         // On-page links
//         if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
//             // Figure out element to scroll to
//             var target = $(this.hash);
//             target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
//             // Does a scroll target exist?
//             if (target.length) {
//                 // Only prevent default if animation is actually gonna happen
//                 event.preventDefault();
//                 jQuery('html, body').animate({
//                     scrollTop: target.offset().top
//                 }, 1000, function() {
//                     // Callback after animation
//                     // Must change focus!
//                     var $target = $(target);
//                     $target.focus();
//                     if ($target.is(":focus")) { // Checking if the target was focused
//                     return false;
//                     } else {
//                     $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
//                     $target.focus(); // Set focus again
//                     };
//                 });
//             }
//         }
//     });
// });

function backToTop() {
    if (window.pageYOffset > 0) {
        jQuery("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
    }
}